<template>
  <div class="shop">
    <el-row>
      <el-col :span="24">
        <div class="dianpu_top">
          <h3>视频教程</h3>
          <p>关于经理云会员管理系统各功能模块操作视频介绍</p>
        </div>
        <div class="dianpu_main">
          <ul>
            <li>
              <div class="box">
                <!-- <video src="../../assets/video/交接.mp4" width="106%" controls></video> -->
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODYwMy5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>交接</p>
            </li>
            <li>
              <div class="box">
                <a target="_blank" href="http://www.56.com/u48/v_MTU5MDk0NDQ1.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>会员充值</p>
            </li>
            <li>
              <div class="box">
                <a target="_blank" href="http://www.56.com/u60/v_MTU5MDkwOTM3.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>加工</p>
            </li>
            <li>
              <div class="box">
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODI0Mi5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>售卖</p>
            </li>
            <li>
              <div class="box">
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODUwOS5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>库存</p>
            </li>
            <li>
              <div class="box">
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODY0OC5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>打卡</p>
            </li>
            <li>
              <div class="box">
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0Nzk5NS5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>打印标签与出库</p>
            </li>
            <li>
              <div class="box">
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODYzNC5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>打印系列码</p>
            </li>
            <li>
              <div class="box">
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODE3NC5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="106%" alt=""></a>
              </div>
              <p>问题商品</p>
            </li>
          </ul>
        </div>
        <!-- 移动端 -->
        <div class="small">
          <ul>
            <li>
              <h2>交接</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/交接.mp4" width="106%" controls></video> -->
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODYwMy5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
            <li>
              <h2>会员充值</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/会员充值.mp4" width="106%" controls></video> -->
                <a target="_blank" href="http://www.56.com/u48/v_MTU5MDk0NDQ1.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
            <li>
              <h2>加工</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/加工.mp4" width="106%" controls></video> -->
                 <a target="_blank" href="http://www.56.com/u60/v_MTU5MDkwOTM3.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
            <li>
              <h2>售卖</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/售卖.mp4" width="106%" controls></video> -->
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODI0Mi5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
            <li>
              <h2>库存</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/库存.mp4" width="100%" controls></video> -->
                 <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODUwOS5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
            <li>
              <h2>打卡</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/打卡.mp4" width="100%" controls></video> -->
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODY0OC5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
            <li>
              <h2>打印标签与出库</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/打印标签与出库.mp4" width="100%" controls></video> -->
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0Nzk5NS5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
            <li>
              <h2>打印系列码</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/打印系列码.mp4" width="100%" controls></video> -->
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODYzNC5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
            <li>
              <h2>问题商品</h2>
              <div class="bbb">
                <!-- <video src="../../assets/video/问题商品.mp4" width="100%" controls></video> -->
                <a target="_blank" href="https://tv.sohu.com/v/dXMvMzQyOTI4OTc3LzE0NTQ0ODE3NC5zaHRtbA==.html"><img src="../../assets/images/homeImg/video.png" width="100%" alt=""></a>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.shop {
  .dianpu_top {
    width: 100%;
    text-align: center;
    margin: 60px 0;
    h3 {
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 25px;
      color: rgba(63, 64, 78, 1);
    }
    p {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 30px;
      color: rgba(63, 64, 78, 1);
      margin-top: 19px;
    }
    @media screen and (max-width: 850px) {
      margin: 30px 0;
      h3{
        font-size: 14px;
      }
      p{
        font-size: 12px;
        margin-top: 9px;
      }
    }
  }
  @media screen and (max-width: 850px) {
    .dianpu_main {
      display: none;
    }
  }
  @media screen and (min-width: 850px) {
    .small {
      display: none;
    }
  }
  .dianpu_main {
    // padding: 0 25px;
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    margin-bottom: 115px;
    margin-top: 65px;
    ul {
      li {
        text-align: center;
        float: left;
        width: 386px;
        height: 260px;
        margin: 0 20px 50px 0;
        p {
          font-size: 18px;
          font-weight: 600;
        }
        .box {
          margin: 0 22px 10px 0;
        }
        &:nth-of-type(3) {
          margin-right: 0;
        }
        &:nth-of-type(6) {
          margin-right: 0;
        }
        &:nth-of-type(9) {
          margin-right: 0;
        }
      }
    }
  }
  .small {
    // padding: 0 37px;
    ul {
      li {
        width: 100%;
        margin-bottom: 20px;
        &:nth-last-of-type(1){
          margin-bottom: 100px;
        }
        h2 {
          font-size: 16px;
          color: #2e2e2e;
          font-weight: 400;
          margin: 11px 0;
          position: relative;
          padding-left: 28px;

          &::after {
            content: "";
            background-color: #258ffc;
            border-radius: 5.5px;
            width: 4px;
            height: 16px;
            overflow: hidden;
            position: absolute;
            top: 3px;
            left: 13px;
          }
        }
        .bbb {
          width: 80%;
          margin: 0 auto;
          video {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>